// extracted by mini-css-extract-plugin
export var option = "_4l-1";
export var optionActive = "_4l-2";
export var pill = "_4l-0";